import { Component, Input, ViewChild, Directive, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import * as numberFormatting from '../../libs/jsCalc/numberFormatting';
import * as Highcharts from 'highcharts';
import * as HighchartsMore from 'highcharts/highcharts-more';
import { ChartDefaults } from './chartdefaults';

@Component({
    selector: 'basicarea',
    template: require('./basicarea.html')
})

export class BasicAreaComponent implements OnDestroy, OnInit {
    @Input() data:any;
    @Input() categorylabels:Array<any>;
    @Input() serieslabels:Array<any>;
    @Input() year:string = "";
    @Input() chartoptions:any = "";
    @Input() min:number;
    @Input() max:number;
    @Input() yAxisTickInterval:number;
    @Input() numberformat:string = "";
    @Input() charttitle:string = "";
    @Input() width:number;
    @Input() height:number;
    @Input() linewidth = "";
    @Input() charttitleoffsety:number = -35;
    @Input() chartmargintop:number = 0;
    @Input() legendalign = "right";
    @Input() legendverticalalign = "middle";
    @Input() legendlayout = "vertical";

    private chart:any = null;
    private observer:any;
    private gaugeVal:number = 0;
    private $elementRef:any = ElementRef;
    private el:ElementRef = null;
    private localDataArray = [];
    private localCategoryLabelsArray = [];
    private localSeriesLabelsArray = [];
    
    private chartData: any; 

    constructor(el: ElementRef, private chartDefaults: ChartDefaults) {
        let self = this;
        self.el = el;
        // extend highcharts with highcharts-more
        HighchartsMore(Highcharts);
    }

    ngOnDestroy() {
        if (this.chart) {
            this.chart.destroy();
        }
        //this.observer.unsubscribe();
    }

    ngOnInit() {
        var opt = {}, self = this;

        this.chartData = this.chartDefaults.getBasicAreaChartDefaults();

        self.chartData.chart.width = "1000";
        self.chartData.chart.height = "500";
        self.chartData.chart.renderTo = self.el.nativeElement.childNodes[0];

        if (this.min != undefined) {
            self.chartData.yAxis.min = this.min;
        }
        if (this.max != undefined) {
            self.chartData.yAxis.max = this.max;
        }
        if (this.yAxisTickInterval != undefined) {
            self.chartData.yAxis.tickInterval = this.yAxisTickInterval;
        }
        self.chartData.legend.align = this.legendalign;
        self.chartData.legend.verticalAlign = this.legendverticalalign;
        self.chartData.legend.layout = this.legendlayout;

        if (this.charttitle != "") {
            self.chartData.title.text = this.charttitle;
        }

        for (let i = 0; i < self.categorylabels.length; i++) {
            self.chartData.xAxis.categories[i] = self.categorylabels[i];
        }

        for (let i = 0; i < self.serieslabels.length; i++) {
            let localDataArray = [];
            let seriesName = self.serieslabels[i];
            for (let j = 0; j < self.data[seriesName].length; j++) {
                localDataArray.push(Number(self.data[seriesName][j]));
            }

            self.chartData.series.push ({
                name: seriesName,
                data: localDataArray,
                lineWidth: 1
            });
        }
        
        if (self.chartoptions !== "")
            self.chartoptions = JSON.parse(self.chartoptions);

        _.merge(opt, self.chartData, self.chartoptions);

        self.chart = new Highcharts.Chart(opt);
        //this.processChartInputs();
    }

    /*processChartInputs() {
        let self = this;
        let localRangeRef = self.rangeref;
        let localCategoryLabels = self.categorylabels;
        let localSeriesLabels = self.serieslabels;

        if (localRangeRef != undefined) {
            localRangeRef = localRangeRef.replace(/\[|\]/g, '');
            localRangeRef = localRangeRef.replace(/ /g, '');
            this.localRangeRefArray = localRangeRef.split(",");
        }

        if (localCategoryLabels != undefined) {
            localCategoryLabels = localCategoryLabels.replace(/\[|\]/g, '');
            localCategoryLabels = localCategoryLabels.replace(/ /g, '');
            this.localCategoryLabelsArray = localCategoryLabels.split(",");
        }

        if (localSeriesLabels != undefined) {
            localSeriesLabels = localSeriesLabels.replace(/\[|\]/g, '');
            localSeriesLabels = localSeriesLabels.replace(/ /g, '');
            this.localSeriesLabelsArray = localSeriesLabels.split(",");
        }

        if (this.min != undefined) {
            self.chartData.yAxis.min = this.min;
        }
        if (this.max != undefined) {
            self.chartData.yAxis.max = this.max;
        }

        self.chartData.legend.align = this.legendalign;
        self.chartData.legend.verticalAlign = this.legendverticalalign;
        self.chartData.legend.layout = this.legendlayout;

        if (this.charttitle != "") {
            //self.chartData.title.text = this.textengineService.getText(this.charttitle);
        }


    }*/
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/charts/basicarea.ts